import React, { useCallback, useEffect } from 'react';

import { Flex, Space } from 'antd-v5';
import _ from 'lodash';
import { MdCheckCircle } from 'react-icons/md';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Search, Text } from 'scouting-ui/lib';
import { ToolbarButton } from 'scouting-ui/lib/Button';

import { intl } from '@shared/localization';

import {
  approvalSelectionCountSel,
  emptyApprovalSelectionSel,
} from '../duck/selectors';
import { mbcDashboardActions } from '../duck/slice';
import ApproveConfirmationModal from './ApproveConfirmationModal';
import styles from './DashboardTabYouth.module.scss';
import MeritBadgesTable from './MeritBadgesTable';
import RequirementsTable from './RequirementsTable';

export default function DashboardTabApprove() {
  const emptySelection = useSelector(emptyApprovalSelectionSel);
  const dispatch = useDispatch();
  const selectionCount = useSelector(approvalSelectionCountSel);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const onSearch = useCallback(
    _.debounce((query: string) => {
      dispatch(mbcDashboardActions.setYouthSearch(query));
    }, 300),
    [dispatch],
  );

  // clean when unmounted
  useEffect(
    () => () => {
      dispatch(
        mbcDashboardActions.resetItem(['selectedRequirements', 'youthSearch']),
      );
    },
    [dispatch],
  );

  return (
    <Flex vertical className={styles.tabContainer}>
      <Flex align="center" gap={'large'} className={styles.tableHeader}>
        <Space align="center" size={'large'}>
          <ToolbarButton
            icon={<MdCheckCircle />}
            disabled={emptySelection}
            onClick={() =>
              dispatch(
                mbcDashboardActions.setModal({
                  modal: 'toApprove',
                  open: true,
                }),
              )
            }
          >
            <FormattedMessage id="mbcDashboard.actions.approve" />
          </ToolbarButton>
        </Space>
        <div style={{ justifySelf: 'flex-end', flex: '1 1 auto' }} />
        {selectionCount > 0 ? <Text>({selectionCount} selected)</Text> : null}
        <div>
          <Search
            onChange={event => {
              const value = event.target.value;
              onSearch(value);
            }}
            width={320}
            placeholder={intl.formatMessage({
              id: 'mbcDashboard.actions.search',
            })}
          />
        </div>
      </Flex>
      <ApproveConfirmationModal />
      <MeritBadgesTable />
      <RequirementsTable />
    </Flex>
  );
}
